import { format } from '@aloft/toolkit-shared';

import { ValueFormatter } from '../../types.ts';

export const percent: ValueFormatter = (num?: number) => {
  return {
    str: [format.percent(num) ?? ''],
  };
};
